import axios from "axios";
import { getAuth, getAuthHeaders } from "../pages/TokenStorage";

axios.defaults.withCredentials = true;

const API_BASE = "https://api.instilit.com/api";

export const login = async (formData) => {
  try {
    const response = await axios.post(`${API_BASE}/login/`, formData, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json"
      },
    });
    console.log("Login response data:", response.data);
    console.log("Login response headers:", response.headers);

    const sessionid = response.data.sessionid;
    console.log("Session ID:", sessionid);
    const cookieHeader = `sessionid=${sessionid}`;
    // Save the cookie header to sessionStrorage or state  
    sessionStorage.setItem('cookieHeader', cookieHeader);
   
      const csrfToken = await getCsrfToken();
    console.log("CSRF Token fetched right after login:", csrfToken);


    return {
      cookieHeader
    };

  } catch (error) {
    console.error("Login failed:", error.response?.data || error.message);
    return null;
  }
};

export const getCsrfToken = async () => {
  try {
    const response = await axios.get(`${API_BASE}/csrf/`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      },
    });
    console.log("CSRF Token response data:", response.data);

    const csrfToken = response.data.csrfToken;
    console.log("CSRF Token:", csrfToken);
    
    sessionStorage.setItem('csrfToken', csrfToken);
  
    
    return response.data.csrfToken; 
  }
  catch (error) {
    console.error("Failed to fetch CSRF token:", error.response?.data || error.message);
    return null;
  }
};

export const signup = async (formData) =>
  axios.post(`${API_BASE}/register/`, formData, {
    withCredentials: true,
  });

export const checkLoginStatus = async ({ cookieHeader, csrftoken, sessionid } = {}) => {
  try {
    const res = await axios.get(`${API_BASE}/checklogin/`, {
      withCredentials: true,
      headers: {
        "Content-Type": "application/json",
      }
      
    });
    console.log("CheckLogin response data:", res.data);
    console.log("CheckLogin response headers:", res.headers);
  } catch (error) {
    if (error.response) {
      console.error("CheckLogin failed:", error.response.data);
      console.error("Headers:", error.response.headers);
    } else {
      console.error("CheckLogin error:", error.message);
    }
  }
};

export const logout = async () => {
  console.log("Logging out...", getAuthHeaders());

  try {
    const res = await axios.post(`${API_BASE}/logout/`, {}, {
      withCredentials: true,
      headers: getAuthHeaders()
    });
    console.log("Logout response:", res.data);

    sessionStorage.removeItem('csrfToken');
    sessionStorage.removeItem('cookieHeader');
  } catch (err) {
    console.error("Logout failed:", err.response?.data || err.message);
  }
};

// ------------------ PROFILE ------------------
export const getProfile = async () => {
  try {
    const response = await axios.get(`${API_BASE}/register/details`, {
      headers: getAuthHeaders()
    });
    console.log("Profile response data:", response.data);
    return response.data;
   
  } catch (error) {
    console.error("Error fetching profile:", error.response?.data || error.message);
    throw error;
  }
};

export const getProfileAnother = async () => {
  try {
    const response = await axios.get(`${API_BASE}/profile/`, {
      headers: getAuthHeaders()
    });
    console.log("Profile response data:", response.data);
    return response.data;
  } catch (error) {
    console.error("Error fetching profile:", error.response?.data || error.message);
    throw error;
  }
};


export const postProfile = (formData) => {
  try {
    return axios.patch(`${API_BASE}/profile/`, formData, {
      headers: getAuth(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error posting profile:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }
};

export const postOtherFields = (formData) => {
  try {
    return axios.patch(`${API_BASE}/register/details/`, formData, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error posting other fields:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }
};



// ------------------ SKILLS ------------------
export const addSkill = (data) => {
  try {
    return axios.post(`${API_BASE}/skills/`, data, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error adding skill:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }   
}
export const updateSkill = (id, data) => {
  try {
    return axios.put(`${API_BASE}/skills/${id}`, data, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error updating skill:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }
};
export const getSkills = () => axios.get(`${API_BASE}/skills/`);

export const getSkillById = (id) => axios.get(`${API_BASE}/skills/${id}/`);

export const deleteSkill = (id) => {
  try {
    return axios.delete(`${API_BASE}/skills/${id}`, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error deleting skill:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }     
}
// ------------------ EDUCATION ------------------
export const getEducations = () => axios.get(`${API_BASE}/education/`);

export const postEducation = (data) => {
  try {
    return axios.post(`${API_BASE}/education/`, data, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error posting education:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }   
}
export const deleteEducation = (id) => {
  try {
    return axios.delete(`${API_BASE}/education/${id}`, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error deleting education:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }     
}

export const updateEducation = (id, data) => {
  try {
    return axios.put(`${API_BASE}/education/${id}`, data, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error updating education:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }   
}

export const getEducationById = (id) => 
     axios.get(`${API_BASE}/education/${id}`);
  


// ------------------ EXPERIENCE ------------------
export const getExperiences = () => axios.get(`${API_BASE}/experience/`);

export const getExperienceById = (id) => axios.get(`${API_BASE}/experience/${id}`);
export const updateExperience = (id, data) => {
  try {
    return axios.put(`${API_BASE}/experience/${id}`, data, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error updating experience:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }
}

export const postExperience = (data) =>{
  try {
    return axios.post(`${API_BASE}/experience/`, data, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error posting experience:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }   
}
export const deleteExperience = (id) => {
  try {
    return axios.delete(`${API_BASE}/experience/${id}`, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error deleting experience:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }     
}

// ------------------ PROJECTS ------------------
export const getProjects = () => axios.get(`${API_BASE}/projects/`);
export const getProjectById = (id) => axios.get(`${API_BASE}/projects/${id}`);
export const postProject = (data) => {
  try {
    return axios.post(`${API_BASE}/projects/`, data, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error posting project:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }   
}
export const updateProject = (id, data) => {
  try {
    return axios.put(`${API_BASE}/projects/${id}`, data, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error updating project:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }
}
export const deleteProject = (id) => {
  try {
    return axios.delete(`${API_BASE}/projects/${id}`, {
      headers: getAuthHeaders(), // Use the function to get headers
    });
  }
  catch (error) {
    console.error("Error deleting project:", error.response?.data || error.message);
    throw error; // Re-throw the error for further handling if needed
  }     
}
// ------------------ CONTACTS ------------------
export const getContacts = () => axios.get(`${API_BASE}/contacts/`);

// ------------------ COURSES ------------------
export const getCourses = () => axios.get(`${API_BASE}/courses/`);
export const getCourseDetails = () => axios.get(`${API_BASE}/api/courses/detail/`);


// ------------------ USER REVIEWS ------------------
export const fetchTestimonials = () => axios.get(`${API_BASE}/userreviews/`);

// ------------------ TUTORIALS ------------------
export const getTutorials = () => axios.get(`${API_BASE}/tutorials/`);

// ------------------ YOUTUBE VIDEOS ------------------
export const getYoutubeVideos = () => axios.get(`${API_BASE}/youtubevideos/`);


